module.exports = __webpack_public_path__ + "static/media/rfm_cube.8ccad615.png";